import type { UserRole } from '../types';

/** Super admin should have access to every screen in the app. */
export const isSuperAdmin = (role?: UserRole | string | null): boolean => role === 'super_admin';
